module.exports = __webpack_public_path__ + "static/media/share-icon.c4851c80.svg";